import {openDeleteDialog, showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {head} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {useDeleteArticleUpdateJobMutation} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {warehouseRoutes} from '@dms/routes';
import {
  DmsDataGrid,
  WAREHOUSE_GRID_CODES,
  catchUnhandledDataGridActions,
  handleApiError,
} from '@dms/shared';
import {FullscreenDataGridWrapper} from '@dms/warehouse/shared-components';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function UpdateJobsList() {
  const navigate = useNavigate();

  const [deleteJobs] = useDeleteArticleUpdateJobMutation();

  const actionCallback: ActionCallback = ({
    actionKey,
    rowId,
    refreshData,
    deselectAll,
    sourceSearchParams,
  }) => {
    match(actionKey)
      .with('redirect', 'redirectDetail', () => {
        const id = isArray(rowId) ? head(rowId) : rowId;
        navigate(
          composePath(warehouseRoutes.updateJobDetailOverview, {
            params: {id},
            isSearchParamsPreserved: false,
            queryParams: sourceSearchParams,
          })
        );
      })
      .with('delete', () => {
        const ids = isArray(rowId) ? rowId : [rowId];
        openDeleteDialog({
          onConfirm: () =>
            deleteJobs({articleUpdateJobId: ids})
              .unwrap()
              .then(() =>
                showNotification.success(i18n.t('general.notifications.successfullyDeleted'))
              )
              .then(deselectAll)
              .then(() => refreshData())
              .catch(handleApiError),
        });
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <FullscreenDataGridWrapper hideCardWrapper>
      <DmsDataGrid
        gridCode={WAREHOUSE_GRID_CODES.articleUpdateJobs}
        actionCallback={actionCallback}
        data-testid={WAREHOUSE_GRID_CODES.articleUpdateJobs}
      />
    </FullscreenDataGridWrapper>
  );
}
